import styled from '@emotion/styled';
import { Typography } from '@material-ui/core';
import { Backup } from '@material-ui/icons';
import { ClassAttributes, createElement } from 'react';

import theme from '../../../../theme';
import { flexibleLayoutContainer } from '../../../styleUtility/flexibleLayout';

type Props = ClassAttributes<HTMLElement> & {
  className?: string;
};

const Indicator = ({ className }: Props) => (
  <Root className={className}>
    <Icon color="primary" />

    <Description>Drop down files to upload</Description>
  </Root>
);

const Root = styled('div')({
  ...flexibleLayoutContainer({
    direction: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  }),
});

const Icon = styled(Backup)({
  width: 80,
  height: 80,
});

const Description = styled(Typography)({
  padding: '8px 16px',
  background: theme.palette.primary.main,
  borderRadius: '18px',
  color: '#fff',
});

export default Indicator;
